// An update-data event is applied to the memory DB when it is about the
// tenant and the branch the worker loaded, and it was not caused by this
// client (which refreshed already, from the response of its write). Events
// without a branch (backend before the batch save) are applied as before.
export function shouldApplyUpdate(data, { tenant, branch, socketId }) {
  if (!data || data.tenant !== tenant || data.callerId === socketId)
    return false;
  if (data.branch && data.branch !== branch) return false;

  return true;
}
